var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircleBrokenDownRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41051 2.33938C12.7467 1.44846 16.4538 2.31164 19.0711 4.92893C22.9764 8.83418 22.9764 15.1658 19.0711 19.0711C15.1659 22.9763 8.83424 22.9763 4.92899 19.0711C2.3117 16.4538 1.44852 12.7466 2.33944 9.41045M15.0002 9.00001V15M15.0002 15H9.0002M15.0002 15L5.00001 4.99995",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleBrokenDownRight);
export default __webpack_public_path__ + "static/media/arrow-circle-broken-down-right.cba20118af042fae56c42995c1558877.svg";
export { ForwardRef as ReactComponent };